import React from 'react';
import PropTypes from 'prop-types';

const WCAGTab = React.forwardRef((props, ref) => (
  <div id={props.id} ref={ref} tabIndex={props.tabIndex} aria-selected={props.ariaSelected} role={props.role}>
    {props.children}
  </div>
));

WCAGTab.propTypes = {
  children: PropTypes.node,
  tabIndex: PropTypes.string,
  ariaSelected: PropTypes.string,
  role: PropTypes.string,
  id: PropTypes.string,
};

export default WCAGTab;
